module.exports = __webpack_public_path__ + "img/button-doctormovement.656a0fcc.png";